import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { useUsageData } from "@/data/use-usage-data";

import { useGroupUuid } from "@/hooks/use-group-uuid.tsx";

export default function UsagePage() {
  const groupUuid = useGroupUuid();
  const { usage } = useUsageData({ groupUuid });

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Workspace Usage</PageHeader.Title>
      </PageHeader>
      <PageBody>
        <div className="whitespace-pre-wrap">
          {JSON.stringify(usage, null, 2)}
        </div>
      </PageBody>
    </Page>
  );
}
